import fetch from 'auth/FetchInterceptor';

const authSubAdminService = {};
const api = '/sub_admin';
authSubAdminService.getProfile = async function () {
  try {
    const res = await fetch({
      url: `${api}/profile/get`,
      method: 'get'
    });

    return res.data;
  } catch (err) {

  }
};

authSubAdminService.restPassword = async function (data) {
  try {
    const res = await fetch({
      url: `${api}/password/reset`,
      method: 'put',
      data: data
    });

    return res.data;
  } catch (err) {

  }
};

export default authSubAdminService;